import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Paginator from 'react-paginate';
import Fa from '../../utils/Fa';

import './pagination.css';

export default class Pagination extends Component {
  renderPrevNext(direction) {
    return <Fa icon={direction === 'prev' ? 'angle-left' : 'angle-right'} />;
  }

  render() {
    return (
      <nav className="pagination">
        <Paginator
          onPageChange={this.props.onPageChange}
          previousLabel={this.renderPrevNext('prev')}
          nextLabel={this.renderPrevNext('next')}
          breakLabel="&hellip;"
          pageCount={this.props.pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          forcePage={this.props.selectedPage - 1}
        />
      </nav>
    );
  }
}

Pagination.propTypes = {
  pageCount: PropTypes.number,
  selectedPage: PropTypes.number,
  onPageChange: PropTypes.func,
};
